<template>
    <div class="upsell-summary-items">
        <ul class="upsell-summary-items-listing">
            <li
                v-for="(item, index) in subscriptionItemsToBeDisplayed"
                :key="index"
                class="upsell-summary-items-listing__item typographies-paragraph-medium-regular"
            >
                <div class="upsell-summary-items-listing__item-label">
                    <span>
                        <span v-if="item.quantity > 1">{{ item.quantity }}</span>
                        {{ item.label }}
                    </span>

                    <ChargebeeUpsellTag
                        v-if="hasTag(item)"
                        :quantity="item.updatedQuantity"
                        :label="tagLabel(item)"
                        :showQuantity="!isOption(item)"
                    />
                </div>
                <div class="upsell-summary-items-listing__item-price">
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $filters.numberFormatCurrency(humanizeCentsPrice(item.amount)) }}
                    </span>
                    <span v-if="item.recurrence" class="typographies-paragraph-small-regular">
                        /{{ recurrence(item.recurrence) }}
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import ChargebeeUpsellTag from 'vcomponents/pages/account/upsell/ChargebeeUpsellTag.vue';
import ChargebeeUpsellMixin from 'mixins/chargebee/ChargebeeUpsellMixins';
import ChargebeeUpsellV3Mixin from './ChargebeeUpsellV3Mixin';

export default {
    components: { ChargebeeUpsellTag },
    mixins: [ChargebeeUpsellMixin, ChargebeeUpsellV3Mixin],
};
</script>
<style lang="scss" scoped>
.upsell-summary-items {
    display: flex;
    flex-direction: column;

    &-heading {
        display: flex;
        justify-content: space-between;
        margin: 0;
    }

    &-listing {
        margin: 0;

        &__item {
            display: flex;
            justify-content: space-between;

            &-price {
                white-space: nowrap;
            }

            &-label {
                display: flex;
                align-items: center;
                margin-bottom: var(--spacing-0);
            }

            &-price {
                white-space: nowrap;
            }
        }
    }
}
</style>
